import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'shared/components/link'

export const LinkCell = ({ value }) =>
  value ? (
    <Link as="a" title={value} href={value}>
      {value}
    </Link>
  ) : (
    '-'
  )

LinkCell.propTypes = {
  value: PropTypes.any,
}
